export class SearchboxDisplay {
    from: string;
    to: string;
    fromDate: string;
    fromTime: string;
    fromYear: string;
    toDate: string;
    toTime: string;
    toYear: string;
    passengerQty: number;
  }